/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GuidCounterDto } from '../../models/guid-counter-dto';

export interface GetProjectStats$Params {
  id: string;
}

export function getProjectStats(http: HttpClient, rootUrl: string, params: GetProjectStats$Params, context?: HttpContext): Observable<StrictHttpResponse<GuidCounterDto>> {
  const rb = new RequestBuilder(rootUrl, getProjectStats.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GuidCounterDto>;
    })
  );
}

getProjectStats.PATH = '/v0/projects/{id}/stats';
